// extracted by mini-css-extract-plugin
module.exports = {"productImg":"ProductWrapper_productImg__2JPx1","productWrapper":"ProductWrapper_productWrapper__17lrs","string":"ProductWrapper_string__eya87","name":"ProductWrapper_name__31UGg"};